import React from 'react';
import PropTypes from 'prop-types';
import RecentDocuments from '@elliemae/ds-icons/RecentDocuments';
import DSButton from '@elliemae/ds-button';
import DSPopper from '@elliemae/ds-popper';

var TimePickerDropdown = function TimePickerDropdown(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onClick = _ref.onClick,
      onOpen = _ref.onOpen,
      isOpen = _ref.isOpen,
      menu = _ref.menu,
      zIndex = _ref.zIndex,
      blockName = _ref.blockName,
      placement = _ref.placement;
  return /*#__PURE__*/React.createElement(DSPopper, {
    blockName: blockName,
    placement: placement,
    contentComponent: menu,
    isOpen: isOpen,
    onOpen: onOpen,
    modifiers: {
      preventOverflow: {
        enabled: true,
        padding: 0,
        boundariesElement: 'window'
      }
    },
    showArrow: false,
    triggerComponent: /*#__PURE__*/React.createElement(DSButton, {
      buttonType: "secondary",
      disabled: disabled,
      icon: /*#__PURE__*/React.createElement(RecentDocuments, null),
      iconSize: "s",
      onClick: onClick
    }),
    zIndex: zIndex
  });
};

TimePickerDropdown.propTypes = {
  onClick: PropTypes.func,
  onOpen: PropTypes.func,
  disabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  menu: PropTypes.element,
  blockName: PropTypes.string,
  placement: PropTypes.string,
  zIndex: PropTypes.number
};

export default TimePickerDropdown;
//# sourceMappingURL=TimePickerDropdown.js.map
